import React, { useState } from "react";
import { Button } from "../ui/button";
import { MONTHS_HI } from "../../data/rssbData";
import * as store from "../../lib/storage";
import { exportPdf } from "../../lib/pdfExport";
import { exportExcel } from "../../lib/excelExport";
import { exportGharSlips, exportPersonSlips } from "../../lib/slipExport";
import { toast } from "sonner";
import { FolderOpen, FileDown, FileSpreadsheet, Home, UserRound, Pencil, Trash2 } from "lucide-react";

const btn = "border-[#6e1b1b]/40 text-[#6e1b1b] hover:bg-[#6e1b1b]/10 gap-1 h-8 px-2.5 text-xs font-dev";

const SavedRow = ({ s, onOpen, onDelete }) => {
  const [y, m] = s.monthKey.split("-").map(Number);
  const res = s.result;
  const v = res.variants.find((x) => x.id === s.selectedId) || res.variants[0];
  const run = async (fn, label) => {
    try {
      await fn(v, res.dates, y, m);
      toast.success(`${label} डाउनलोड हुई`);
    } catch (e) {
      toast.error(`${label} त्रुटि: ${e.message}`);
    }
  };
  return (
    <div data-testid={`saved-row-${s.id}`} className="bg-[#fffdf7] border border-[#e3d6b6] rounded-xl p-4 space-y-3">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <div className="font-serif-dev font-semibold text-[#3a1212] text-lg">{s.name}</div>
          <div className="text-xs text-[#7a4a3a] font-dev">
            {MONTHS_HI[m]} {y} · {s.kind} · सहेजा: {new Date(s.savedAt).toLocaleString("hi-IN", { dateStyle: "medium", timeStyle: "short" })}
          </div>
        </div>
        <div className="flex gap-2">
          <Button data-testid={`saved-open-${s.id}`} onClick={() => onOpen(s)} className="bg-[#6e1b1b] text-[#f3ead6] hover:bg-[#7a1f1f] gap-1 h-8 text-xs font-dev">
            <Pencil className="w-3.5 h-3.5" /> खोलें व बदलें
          </Button>
          <Button data-testid={`saved-delete-${s.id}`} variant="outline" onClick={() => onDelete(s)} className="border-[#b91c1c]/40 text-[#b91c1c] h-8 px-2">
            <Trash2 className="w-3.5 h-3.5" />
          </Button>
        </div>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button data-testid={`saved-bw-${s.id}`} variant="outline" className={btn} onClick={() => run((a, b, c, d) => exportPdf(a, b, c, d, "bw"), "B&W PDF")}><FileDown className="w-3.5 h-3.5" /> B&W हिंदी PDF</Button>
        <Button data-testid={`saved-color-${s.id}`} variant="outline" className={btn} onClick={() => run((a, b, c, d) => exportPdf(a, b, c, d, "color"), "C-हिंदी PDF")}><FileDown className="w-3.5 h-3.5" /> C-हिंदी PDF</Button>
        <Button data-testid={`saved-excel-${s.id}`} variant="outline" className={btn} onClick={() => run(exportExcel, "Excel")}><FileSpreadsheet className="w-3.5 h-3.5" /> Excel</Button>
        <Button data-testid={`saved-ghar-slips-${s.id}`} variant="outline" className={btn} onClick={() => run(exportGharSlips, "घर स्लिप")}><Home className="w-3.5 h-3.5" /> घर स्लिप</Button>
        <Button data-testid={`saved-person-slips-${s.id}`} variant="outline" className={btn} onClick={() => run(exportPersonSlips, "सेवादार स्लिप")}><UserRound className="w-3.5 h-3.5" /> सेवादार स्लिप</Button>
      </div>
    </div>
  );
};

export const SavedTab = ({ onOpen }) => {
  const [, setVer] = useState(0);
  const snaps = store.getSnapshots();
  const onDelete = (s) => {
    if (!window.confirm(`"${s.name}" हटाएं?`)) return;
    store.deleteSnapshot(s.id);
    setVer((v) => v + 1);
    toast.success("सहेजा शेड्यूल हटाया गया");
  };
  return (
    <div className="space-y-3" data-testid="saved-tab">
      <h2 className="font-serif-dev font-semibold text-[#3a1212] flex items-center gap-2 text-lg">
        <FolderOpen className="w-5 h-5 text-[#6e1b1b]" /> सहेजे गए शेड्यूल ({snaps.length})
      </h2>
      {snaps.map((s) => (
        <SavedRow key={s.id} s={s} onOpen={onOpen} onDelete={onDelete} />
      ))}
      {!snaps.length && (
        <p className="text-sm text-[#9a7a5a] font-dev py-10 text-center">अभी कोई शेड्यूल सहेजा नहीं गया — प्लानर में शेड्यूल बनाकर "शेड्यूल सहेजें" दबाएं</p>
      )}
    </div>
  );
};
